import { render, staticRenderFns } from "./BankDataSettings.vue?vue&type=template&id=f37b8ed8&scoped=true"
import script from "./BankDataSettings.vue?vue&type=script&lang=ts"
export * from "./BankDataSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37b8ed8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f37b8ed8')) {
      api.createRecord('f37b8ed8', component.options)
    } else {
      api.reload('f37b8ed8', component.options)
    }
    module.hot.accept("./BankDataSettings.vue?vue&type=template&id=f37b8ed8&scoped=true", function () {
      api.rerender('f37b8ed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/BankDataSettings.vue"
export default component.exports